// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import AdministratorStatistics from './AdministratorStatistics';

export default compose(
  connect(
    state => ({
      userRole: state.global.user.role
    }),
    dispatch => ({}),
  ),
)(AdministratorStatistics);
